import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconHourglass } from '@sorare/core/src/atoms/icons/system/iconHourglass.ts';

import { kycCtaPill } from '../ui.tsx';

const Root = styled.div`
  --kyc-cta-color: var(--c-white);
  ${kycCtaPill}
`;

export const PendingVerificationCta = () => {
  return (
    <Root>
      <FontAwesomeIcon icon={iconHourglass} />
      <FormattedMessage defaultMessage="Pending verification" />
    </Root>
  );
};
